import React, { FC, memo } from 'react'

import { paths } from '@/constants/paths'
import { useCustomFocus } from '@/hooks/useCustomFocus'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'

import { CalendarDay, CalendarElem, Label } from './styles'

const focusId = 'calendarElem'

const CalendarListRaw: FC = () => {
  const calendar = useStore((state) => state.common.calendar)
  const calendarIndex = useStore((state) => state.common.calendarIndex)
  const setCalendarSelectedIndex = useStore(
    (state) => state.common.setCalendarSelectedIndex,
  )

  const { defaultFocusChild, onMove } = useCustomFocus({ focusId })

  // useEffect(() => {
  //   setDefaultFocusChild(calendarIndex)
  // }, [calendarIndex])

  const onSelected = (index: number) => {
    setCalendarSelectedIndex(index)
    sendPageViewEvent(paths.CALENDAR)
  }

  return (
    <CalendarElem
      elementType="section"
      focusId={focusId}
      defaultFocusChild={defaultFocusChild}
      onMove={onMove}
    >
      {calendar.map((entry, index) => (
        <CalendarDay
          className={`${calendarIndex === index && 'isActiveFilter'}`}
          onSelected={() => onSelected(index)}
          key={entry.date}
        >
          <Label>{entry.name}</Label>
        </CalendarDay>
      ))}
    </CalendarElem>
  )
}

export const CalendarList = memo(CalendarListRaw)
